const newsletter = () => {
  const selectors = [
    '.footer__misc-list li:first-child a',
    '.newsletter-toggle'
  ]
  const modal = document.querySelector('.newsletter');
  const modalTriggers = document.querySelectorAll(selectors);

  // code has been moved to GTM and using a salesforce popup
  modalTriggers.forEach(modalTrigger => {
    modalTrigger.addEventListener('click', e => {
      e.preventDefault()
      modal.classList.toggle('newsletter--active');
    })
  })
}

function init() {
  newsletter()
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/newsletter.js